/* global __webpack_public_path__ */

const runtimeConfig = window.__STOP_CONFIG__ || {};

let publicPath =
  runtimeConfig?.URL?.PUBLIC_PATH ||
  runtimeConfig?.URL?.STOP_APP_BASENAME ||
  "/";

// Si viene path relativo, lo convertimos a absoluto
if (!/^https?:\/\//i.test(publicPath) && !publicPath.startsWith("/")) {
  publicPath = `/${publicPath}`;
}

// Asegurar slash final
if (!publicPath.endsWith("/")) {
  publicPath += "/";
}

__webpack_public_path__ = publicPath;